/* eslint-disable import/prefer-default-export */

export const validateFieldsAtSubmit = async (
  values: any,
  columnMappings: any,
  fillingStatus: string,
  globalActions: any,
  t: any,
  displayStyles: Record<string, string> = {},
) => {
  const errors: string[] = [];

  if (fillingStatus === 'empty') return true;

  // Helper function to check if field is hidden
  const isFieldHidden = (fieldName: string) => displayStyles[fieldName] === 'hidden';

  // Check if any volume fields are provided (only if not hidden)
  const hasVolumeFields = (!isFieldHidden('mass') && Boolean(values?.mass?.value))
    || (!isFieldHidden('containerMass') && Boolean(values?.containerMass?.value));

  // Check if any ABV fields are provided (only if not hidden)
  const hasAbvFields = !isFieldHidden('volumetricMass') && Boolean(values?.volumetricMass?.value);

  // Check if any custom fields are provided
  const hasCustomFields = Object.keys(values).some((key) => {
    // Check if this is a custom field (not a standard field)
    const standardFields = ['mass', 'containerMass', 'volumetricMass', 'totalCapacity', 'usableCapacity'];
    if (standardFields.includes(key)) return false;

    // Check if the field has a value
    return Boolean(values[key]?.value);
  });

  // Allow submission if any fields are provided (volume, ABV, or custom fields)
  if (!hasVolumeFields && !hasAbvFields && !hasCustomFields) {
    errors.push(t('operation.barrel.errors.noFieldsProvided'));
    globalActions.setSnackbarMessage({ message: t('volume_or_tav_fields'), severity: 'warning' });
    return false;
  }

  // Simplified validation logic for weighed containers:
  // Allow any field updates without complex validation
  // The status completion logic is handled in Operation.js

  if (errors.length > 0) {
    globalActions.setSnackbarMessage({ message: errors.join(', '), severity: 'warning' });
    return false;
  }

  return true;
};
